export default __webpack_public_path__ + "static/media/Factory3.08816b09.jpg";